<template>
    <CieloLayout layout-version="v1">
        <div class="container text-center mt-5">
            <h1 class="error-title" tabindex="0">
                Oppsss!
            </h1>
            <h2 class="error-subtitle mt-3" tabindex="0">
                Este link de pagamento é inválido
            </h2>
            <span class="error-description d-block mt-5" tabindex="0">O link que você está tentando acessar não existe ou está
                expirado.</span>
        </div>
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);

export default {
    components: {
        CieloLayout
    }
};
</script>

<style lang="scss" scoped>
.error-title {
    font-size: 50px;
    font-weight: 700;
    color: $cielo-blue;
}

.error-subtitle {
    font-size: 25px;
    font-weight: 300;
    color: $cielo-blue;
}

.error-description {
    color: #5d666b;
}
</style>